export default class RequestAssigneeSummaryModel {
  assigneeType: string;
  id: string;
  name: string;
  isDisabled: boolean;
  isGroupEmpty: boolean;
  isGroupContactActive: boolean;
  value: string;

  constructor(serverModel: any) {
    this.assigneeType = serverModel.assigneeType;
    this.id = serverModel.id;
    this.name = serverModel.name;
    this.isDisabled = serverModel.isDisabled;
    this.isGroupEmpty = serverModel.isGroupEmpty;
    this.isGroupContactActive = serverModel.isGroupContactActive;
    this.value = `${serverModel.assigneeType}-${serverModel.id}`;
  }
}
